import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpModule } from './http.module';

@Injectable({
  providedIn: HttpModule,
})
export class SSEClinetService {
  constructor(private _zone: NgZone) {}

  getServerSentEvent(httpEndpoint: string): Observable<any> {
    return new Observable((observer) => {
      const eventSource = this.getEventSource(httpEndpoint);
      eventSource.onmessage = (event) => {
        this._zone.run(() => {
          observer.next(event);
        });
      };
      eventSource.onerror = (error) => {
        this._zone.run(() => {
          observer.error(error);
        });
      };
    });
  }

  private getEventSource(httpEndpoint: string): EventSource {
    return new EventSource(httpEndpoint);
  }
}
